// MuiCheckbox.ts
import type { Theme } from '@mui/material/styles';

const getMuiCheckbox = () => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      /*
       * DEFAULT (unchecked)
       * ------------------------------------------------
       */
      '&:not(.Mui-checked)': {
        backgroundColor: theme.palette.background?.default,
      },

      /*
       * TYPOGRAPHY SPACING
       * ------------------------------------------------
       * Keep the label text aligned with the new checkbox height
       */
      '& + .MuiTypography-root': {
        lineHeight: '24px',
        fontSize: '14px',
      },

      /*
       * ERROR STATE
       * ------------------------------------------------
       */
      "&[class*='error']": {
        border: `1px solid ${theme.palette.error.main}`,

        "&[class*='checked']:hover": {
          backgroundColor: theme.palette.semantic.interactive.critical.hover,
          border: `1px solid ${theme.palette.semantic.interactive.critical.hover}`,
        },

        '& + .MuiTypography-root': {
          color: theme.palette.error.main,
        },
      },

      /*
       * CHECKED STATES
       * ------------------------------------------------
       * 1. Stand-alone checkbox (`input` or `.MuiCheckbox-root`)
       * 2. Checkbox inside a MenuItem
       * → both should have identical black bg/border
       */
      "input[type='checkbox']:checked, .MuiCheckbox-root.Mui-checked": {
        backgroundColor: theme.palette.common.black,
        borderColor: theme.palette.common.black,
      },
      '.MuiMenuItem-root .MuiCheckbox-root.Mui-checked': {
        backgroundColor: theme.palette.common.black,
        borderColor: theme.palette.common.black,
      },
    }),
  },
});

export default getMuiCheckbox;
